export default class PaymentProfile {
    constructor() {
        this.init();
    }

    init() {
        this.setupDefaultSelection();
        this.setupEventListeners();
    }

    setupDefaultSelection() {
        const profiles = document.querySelectorAll('input[name="payment_profile"]');
        const hasChecked = Array.from(profiles).some(profile => profile.checked);

        if (profiles.length > 0 && !hasChecked) {
            profiles[0].checked = true;
        }
    }

    setupEventListeners() {
        const updateButton = document.getElementById('update-payment-profile-button');

        if (updateButton) {
            updateButton.addEventListener('click', this.handleUpdateProfile.bind(this));
        }
    }

    handleUpdateProfile(event) {
        const subscription = document.getElementById('payment-profile-subscription').value;
        const selectedProfile = document.querySelector('input[name="payment_profile"]:checked');
        const loader = document.querySelector('.loader');
        const messageEl = document.getElementById('update-message');

        if (!selectedProfile) {
            messageEl.textContent = vindiTranslations.selectCard || 'Por favor, selecione um cartão.';
            messageEl.classList.add('error');
            messageEl.classList.remove('success');
            return;
        }

        event.currentTarget.disabled = true;
        if (loader) loader.style.display = 'block';
        messageEl.textContent = '';
        messageEl.classList.remove('error', 'success');

        const formData = new FormData();
        formData.append('action', 'update_payment_profile');
        formData.append('subscription', subscription);
        formData.append('payment_profile', selectedProfile.value);

        fetch(ajaxurl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(response => {
                if (response.status === 'success') {
                    messageEl.textContent = response.message || (vindiTranslations.cardUpdated || 'Cartão atualizado com sucesso!');
                    messageEl.classList.add('success');

                    document.querySelectorAll('.vindi-card-row').forEach(row => {
                        row.classList.remove('selected-card');
                    });
                    selectedProfile.closest('.vindi-card-row').classList.add('selected-card');
                } else {
                    messageEl.textContent = response.message || (vindiTranslations.updateError || 'Erro ao atualizar cartão.');
                    messageEl.classList.add('error');
                }
            })
            .catch(() => {
                messageEl.textContent = vindiTranslations.requestError || 'Erro ao processar requisição.';
                messageEl.classList.add('error');
            })
            .finally(() => {
                document.getElementById('update-payment-profile-button').disabled = false;
                if (loader) loader.style.display = 'none';
            });
    }
}